import { useEffect, useState } from 'react'
import { bookmakerApi, bmErrorMessage } from '@/api/bookmaker'
import { BmJsonCard, BmPage } from './BmPage'

export function FrontTablePage() {
  const [data, setData] = useState<unknown>(null)
  const [error, setError] = useState<string | null>(null)
  useEffect(() => {
    void bookmakerApi
      .gameList({})
      .then(setData)
      .catch((e) => setError(bmErrorMessage(e)))
  }, [])
  return (
    <BmPage title="Front Table" description="Lab /fronttable" error={error}>
      <BmJsonCard title="Games" data={data} />
    </BmPage>
  )
}
